import React from 'react'
import { Link } from 'react-router-dom'
import MetaDecorator from './metadecorator'
import VideoCarousal from './carousal copy 2'
import AppServices from './appServices'
import Testimonials2 from './testimonials2'
import Faq2 from './faq2'
import AppDevelopmentTypes from './AppDevelopmentTypes'
import ParallaxHero from './ParallaxHero'
import AppProposalForm from './AppProposalForm'
import AppDevelopmentBlogs from './AppDevelopmentBlogs'
import AppDevelopmentLocations from './AppDevelopmentLocations'
import AppDevelopmentSubtypes from './AppDevelopmentSubtypes'
import ReviewedPlatforms from './ReviewedPlatforms'
import OurProcessSection from './OurProcessSection'
import MobileAppTechStack from './MobileAppTechStack'
import WhyTrustMobileApps from './WhyTrustMobileApps'
import AppDevelopmentCostingGuide from './AppDevelopmentCostingGuide'
import GoogleReviewsSection from './GoogleReviewsSection'
import { appDevelopmentTypes } from './appDevelopmentTypeContent'
import { appDevelopmentSubtypesByType } from './appDevelopmentSubtypeContent'
import {
  absoluteUrl,
  createBreadcrumbList,
  createSchemaGraph,
  createServiceItemList,
  createServiceSchema,
  createWebPageSchema,
  organizationSchema,
  websiteSchema
} from '../utils/schemaMarkup'

const defaultProcessSteps = [
  ['01', 'Discover', 'Clarify users, business goals, risks, systems, constraints, and evidence of success.'],
  ['02', 'Design', 'Prototype the critical journeys, content, states, accessibility, and operational controls.'],
  ['03', 'Build & Verify', 'Develop in reviewable releases with automated checks, device QA, security work, and stakeholder acceptance.'],
  ['04', 'Launch & Improve', 'Prepare stores and operations, monitor real use, resolve issues, and prioritize measurable improvements.']
]

const AppDevelopmentTypePage = ({ content }) => {
  const commonKeywords = `Metatech Official is a mobile app development company providing mobile app development services for organizations that need dependable product delivery. Our mobile app development in Pakistan team brings product strategy, UX, engineering, QA, and support together. Clients work directly with experienced mobile app developers in Pakistan and can hire app developer capacity for a focused build or an established roadmap. As a mobile app development agency, we deliver custom app development, custom mobile app development, Android engineering, and iOS app development with scope, risks, and acceptance criteria made clear.`
  const serviceLabel = content.title.toLowerCase()
  const additionalTestimonials = [
    {
      text: `“Metatech helped us turn our ${serviceLabel} concept into a release plan our product, operations, and engineering teams could all follow.”`
    },
    {
      text: `“Weekly reviews kept our ${serviceLabel} priorities visible, and the team explained technical trade-offs without hiding behind jargon.”`
    },
    {
      text: `“The launch was treated as the start of improvement. Real usage data gave us a practical direction for the next ${serviceLabel} release.”`
    }
  ]
  const founderTestimonials = [...content.testimonials, ...additionalTestimonials]
    .slice(0, 6)
    .map((testimonial, index) => ({
      ...testimonial,
      name: content.founderNames[index],
      role: `Founder, ${content.founderVenture}`
    }))
  const processSteps = content.processSteps || defaultProcessSteps
  const currentType = appDevelopmentTypes.find((type) => type.key === content.typeKey)
  const currentSubtypeGroup = appDevelopmentSubtypesByType[content.typeKey]
  const isSubtypePage = Boolean(content.subtypeSlug)
  const currentPath = content.costPath || (isSubtypePage
    ? `/app-development/${currentSubtypeGroup?.slug}/${content.subtypeSlug}`
    : currentType?.slug)
  const appDevelopmentTypeItemList = createServiceItemList({
    id: `${absoluteUrl('/app-development')}#app-development-types`,
    name: 'Types Of App Development We Offer',
    description: 'A list of specialist app development services offered by Metatech Official.',
    items: appDevelopmentTypes
  })
  const subtypeItemList = currentSubtypeGroup
    ? createServiceItemList({
        id: `${absoluteUrl(`/app-development/${currentSubtypeGroup.slug}`)}#${currentSubtypeGroup.key}-app-development-subtypes`,
        name: `Types Of ${currentSubtypeGroup.title} We Offer`,
        description: `A list of ${currentSubtypeGroup.title.toLowerCase()} subtype services offered by Metatech Official.`,
        items: currentSubtypeGroup.subtypes
      })
    : null
  const serviceSchema = createServiceSchema({
    path: currentPath,
    title: content.title,
    description: content.metaDescription,
    imageUrl: content.image,
    serviceType: content.title,
    relatedLinks: isSubtypePage
      ? [...appDevelopmentTypes, ...(currentSubtypeGroup?.subtypes || [])]
      : appDevelopmentTypes
  })
  const breadcrumb = createBreadcrumbList([
    { name: 'Home', url: '/' },
    { name: 'App Development', url: '/app-development' },
    ...(isSubtypePage && currentSubtypeGroup
      ? [
          { name: currentSubtypeGroup.title, url: `/app-development/${currentSubtypeGroup.slug}` },
          { name: content.title, url: currentPath }
        ]
      : [{ name: content.title, url: currentPath }])
  ])
  const schemaMarkup = createSchemaGraph([
    organizationSchema,
    websiteSchema,
    serviceSchema,
    createWebPageSchema({
      path: currentPath,
      title: content.metaTitle,
      description: content.metaDescription,
      imageUrl: content.image,
      breadcrumb,
      mainEntity: [appDevelopmentTypeItemList, subtypeItemList, serviceSchema].filter(Boolean)
    }),
    breadcrumb,
    appDevelopmentTypeItemList,
    subtypeItemList
  ])

  return (
    <main style={{ backgroundColor: '#151619' }}>
      <MetaDecorator title={content.metaTitle} description={content.metaDescription} imageUrl={content.image} showBrand={false} schemaMarkup={schemaMarkup} />
      <VideoCarousal
        imageOnly
        imageURL={content.image}
        fallbackImage={content.fallbackImage}
        imageAlt={`${content.title} mobile application concept`}
        pageTitle={content.title}
      />

      {content.isCostPage && content.pricingTiers && (
        <section className="container py-5 text-light">
          <div className="text-center mb-4">
            <p className="h5 fw-bold mb-3" style={{ color: '#8f8fff', letterSpacing: 1.2 }}>TRANSPARENT PLANNING RANGES</p>
            <h2 className="display-5 fw-bold">{content.costDetails.appName} App Cost Breakdown</h2>
            <p className="lead text-light text-opacity-75 mx-auto" style={{ maxWidth: 850 }}>Competitive delivery ranges for a focused first release. Your final proposal is shaped by confirmed workflows, integrations, and acceptance criteria—not a generic template.</p>
          </div>
          <div className="row g-4">
            {content.pricingTiers.map((tier) => (
              <div key={tier.name} className="col-lg-4">
                <article className="h-100 rounded-4 p-4" style={{ backgroundColor: '#20222d', border: '1px solid rgba(101,101,255,.4)' }}>
                  <p className="small text-uppercase mb-2" style={{ color: '#8f8fff', letterSpacing: 1.2 }}>{tier.name}</p>
                  <h3 className="display-6 fw-bold">{tier.price}</h3>
                  <p className="text-light text-opacity-75">{tier.summary}</p>
                  <ul className="list-unstyled mb-0">
                    {tier.features.map((feature) => <li className="mb-2" key={feature}><i className="fa fa-check-circle me-2" style={{ color: '#6565ff' }} aria-hidden="true" />{feature}</li>)}
                  </ul>
                </article>
              </div>
            ))}
          </div>
          <div className="rounded-4 p-4 mt-4" style={{ backgroundColor: '#0f0f12', border: '1px solid rgba(255,255,255,.08)' }}>
            <h3 className="h4 fw-bold">Deployment and ongoing costs</h3>
            <p className="text-light text-opacity-75 mb-0">Every plan includes release-readiness support for Google Play and Apple App Store submission. Store-account charges, cloud usage, payment processing, mapping, messaging, identity, market-data, AI, and other third-party services are confirmed separately at the provider’s current rate. This makes the total cost visible before launch rather than hiding operational spend inside development pricing.</p>
          </div>
        </section>
      )}

      <section className="container py-5 text-light">
        <div className="row align-items-center">
          <div className="col-lg-8">
            <h2 className="h5 fw-bold" style={{}}>
              {content.sectionEyebrow || 'SPECIALIST APP DEVELOPMENT'}
            </h2>
            <h2 className="display-4 fw-bold mb-4">
              {content.introHeading || `${content.title} Built Around Real Workflows`}
            </h2>
            <p className="lead">{content.intro}</p>
            <p className="lead">{content.expertise}</p>
            <p className="lead mb-0">{content.audience}</p>
          </div>
          <div className="col-lg-4 mt-4 mt-lg-0">
            <div className="p-4 rounded-4" style={{ backgroundColor: '#20222d', border: '1px solid rgba(101,101,255,.55)' }}>
              <p className="small text-uppercase mb-2" style={{ color: '#8f8fff', letterSpacing: 1.5 }}>
                {content.ctaEyebrow || 'Start with clarity'}
              </p>
              <h2 className="h3">{content.ctaHeading || 'Plan a defensible first release'}</h2>
              <p className="text-light text-opacity-75">
                {content.ctaText || 'Share the product goal, target users, required systems, timeline, and known risks. We will turn that context into practical next steps.'}
              </p>
              <Link to="/seo-contact" className="btn btn-primary rounded-pill px-4" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {content.ctaButtonLabel || 'Discuss your app'}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="container pb-5">
        <div className="row">
          {content.outcomes.map((outcome, index) => (
            <div key={outcome} className="col-lg-3 col-sm-6 my-2">
              <div className="h-100 rounded-4 p-4 text-center text-light" style={{ backgroundColor: '#0f0f12', borderTop: '5px solid #6565ff' }}>
                <span className="h2 d-block mb-2" style={{ color: '#6565ff' }}>0{index + 1}</span>
                <h2 className="h5 m-0">{outcome}</h2>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ReviewedPlatforms />

      <ParallaxHero
        title={content.parallaxTitle || `${content.title} From Product Strategy to Launch`}
        subtitle={content.servicesSubtitle}
        imageUrl={content.parallaxImage}
        fallbackImageUrl={content.fallbackParallaxImage}
        speed={1.25}
        widthFromVW={55}
      />

      <OurProcessSection />
      <AppServices title={content.servicesTitle} subtitle={content.servicesSubtitle} services={content.services} />
      <MobileAppTechStack />

      <section className="container py-5 text-light">
        <div className="text-center mb-4">
          <h2 className="h5 fw-bold" style={{}}>
            {content.processEyebrow || 'HOW WE WORK'}
          </h2>
          <h2 className="display-5 fw-bold mb-4">
            {content.processHeading || 'A Product Process You Can Review'}
          </h2>
          <p className="lead text-light text-opacity-75 mx-auto" style={{ maxWidth: 800 }}>
            {content.processIntro || 'Decisions, assumptions, and acceptance criteria stay visible from discovery through support.'}
          </p>
        </div>
        <div className="row">
          {processSteps.map(([number, title, text]) => (
            <div key={number} className="col-lg-3 col-md-6 my-2">
              <div className="p-4 rounded-4 h-100" style={{ backgroundColor: '#20222d', border: '1px solid rgba(255,255,255,.08)' }}>
                <span className="display-6 fw-bold" style={{ color: '#6565ff' }}>{number}</span>
                <h3 className="h4 mt-3">{title}</h3>
                <p className="text-light text-opacity-75 mb-0">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="container pb-5 text-light">
        <div className="rounded-4 p-4 p-lg-5" style={{ background: 'linear-gradient(135deg, #20222d 0%, #12131a 100%)', border: '1px solid rgba(101,101,255,.4)' }}>
          <h2 className="display-6 fw-bold">
            {content.keywordSectionHeading || 'Experienced Mobile Product Delivery From Pakistan'}
          </h2>
          <p className="lead text-light text-opacity-75 mb-0">
            {content.commonKeywordNarrative || commonKeywords}
          </p>
          {!content.isCostPage && !isSubtypePage && content.keywordNarrative && (
            <>
              <h3 className="h4 fw-bold mt-4">
                {content.keywordSectionSubheading || 'Subtype Search and Product Context'}
              </h3>
              <p className="text-light text-opacity-75 mb-0">{content.keywordNarrative}</p>
            </>
          )}
        </div>
      </section>

      <section className="container py-5 text-light">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <h2 className="h5 fw-bold" style={{}}>
              {content.domainEyebrow || 'BUILT FOR YOUR BUSINESS MODEL'}
            </h2>
            <h2 className="display-5 fw-bold mb-4">
              {content.domainHeading || `Why Domain Context Matters in ${content.title}`}
            </h2>
            <p className="lead">{content.expertise}</p>
            <p className="text-light text-opacity-75">{content.audience}</p>
            <div className="row mt-4">
              {content.outcomes.map((outcome) => (
                <div key={outcome} className="col-sm-6 mb-3">
                  <div className="d-flex align-items-start">
                    <i className="fa fa-check-circle me-2 mt-1" style={{ color: '#6565ff' }} aria-hidden="true"></i>
                    <span>{outcome}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="rounded-4 overflow-hidden"
              style={{ border: '1px solid rgba(101,101,255,.55)', boxShadow: '0 24px 60px rgba(0,0,0,.35)' }}
            >
              <img
                src={content.storyImage}
                onError={(event) => {
                  if (content.fallbackStoryImage && event.currentTarget.src !== content.fallbackStoryImage) {
                    event.currentTarget.src = content.fallbackStoryImage
                  }
                }}
                className="w-100"
                style={{ aspectRatio: '4 / 3', objectFit: 'cover' }}
                alt={`${content.title} product strategy and user experience`}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <Testimonials2
        items={founderTestimonials}
        heading={content.testimonialsHeading || `${content.title} Founder Feedback`}
      />
      <WhyTrustMobileApps />
      {!content.isCostPage && currentType && (!isSubtypePage || content.enableSubtypeCostGuide) && (
        <AppDevelopmentCostingGuide
          title={content.title}
          costPath={content.costGuidePath || `${currentType.slug}/cost/`}
          image={content.costGuideImage || `/assets/app-development-types/cost-guides/${content.typeKey}/carousel.png`}
        />
      )}
      {content.isCostPage && content.costDetails && (
        <section className="container pb-5 text-light">
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="h-100 rounded-4 p-4" style={{ backgroundColor: '#20222d', border: '1px solid rgba(101,101,255,.4)' }}>
                <h2 className="h3 fw-bold">How Much Does It Cost to Build a {content.costDetails.appName} App?</h2>
                <p className="text-light text-opacity-75 mb-0">There is no responsible one-size-fits-all figure. Scope, integrations, reliability expectations, and the quality of the first release determine the work. For this product, the main cost drivers are {content.costDetails.drivers}.</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="h-100 rounded-4 p-4" style={{ backgroundColor: '#20222d', border: '1px solid rgba(101,101,255,.4)' }}>
                <h2 className="h3 fw-bold">{content.costDetails.appName} App Development Cost Breakdown</h2>
                <p className="text-light text-opacity-75 mb-0">A transparent cost to develop a {content.costDetails.appName} app separates {content.costDetails.breakdown}. It also identifies ongoing costs early, so the app cost supports a sustainable product plan after launch.</p>
              </div>
            </div>
          </div>
        </section>
      )}
      <Faq2
        items={content.faqs}
        heading={content.faqHeading || `${content.title} FAQs`}
        intro={content.faqIntro || `Practical answers about planning, building, launching, and supporting ${content.title.toLowerCase()}.`}
      />
      <GoogleReviewsSection />
      <AppDevelopmentSubtypes
        typeKey={content.typeKey}
        currentSubtypeSlug={content.subtypeSlug}
        eyebrow={content.subtypesEyebrow}
        heading={content.subtypesHeading}
        intro={content.subtypesIntro}
      />
      <AppDevelopmentTypes
        eyebrow={content.appTypesEyebrow}
        heading={content.appTypesHeading}
        intro={content.appTypesIntro}
      />

      <AppProposalForm
        serviceTitle={content.title}
        eyebrow={content.proposalEyebrow}
        heading={content.proposalHeading}
        submitLabel={content.proposalButtonLabel}
      />
      <AppDevelopmentBlogs
        eyebrow={content.blogsEyebrow}
        heading={content.blogsHeading}
        buttonLabel={content.blogsButtonLabel}
      />
      <AppDevelopmentLocations />
    </main>
  )
}

export default AppDevelopmentTypePage
